export default __webpack_public_path__ + "static/Tek_Shoulder_Cannon-a70c9e08151f9365bd7fbe1b32eeb93c.png";